"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconHeader = _interopRequireDefault(require("../IconHeader"));

var _StatusBox = require("./StatusBox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BareStatusHeader = function BareStatusHeader(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? '2' : _ref$level,
      icon = _ref.icon,
      pass = _ref.pass,
      _ref$na = _ref.na,
      na = _ref$na === void 0 ? false : _ref$na,
      children = _ref.children,
      className = _ref.className;
  return _react.default.createElement("div", {
    className: className
  }, (pass !== null || na) && _react.default.createElement(_StatusBox.StatusBox, {
    pass: pass
  }), _react.default.createElement(_IconHeader.default, {
    level: level,
    icon: icon
  }, children));
};

var StatusHeader = (0, _styledComponents.default)(BareStatusHeader).withConfig({
  displayName: "StatusHeader",
  componentId: "sc-1ftqu9i-0"
})(["display:flex;align-items:center;", "{svg{width:40px;height:40px;}}"], _IconHeader.default);
var _default = StatusHeader;
exports.default = _default;